module.exports = __webpack_public_path__ + "img/Backyard-paws-Colour.a928b822.webp";